import TimeAgo from 'react-timeago';
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import cx from '../../utils/cx.js';
import get from 'lodash/get';
import timeagoTranslations from '../../../app/timeago.js';

const ReactPropTypes = PropTypes;

const fullDay = function(d) {
  var yyyy = d.getFullYear().toString();
  var mm = (d.getMonth()+1).toString(); // getMonth() is zero-based
  var dd  = d.getDate().toString();
  return (dd[1]?dd:"0"+dd[0]) + '.' + (mm[1]?mm:"0"+mm[0]) + '.' + yyyy; // padding
};

const fullDayAndTime = function(d) {
  var yyyy = d.getFullYear().toString();
  var mm = (d.getMonth()+1).toString(); // getMonth() is zero-based
  var dd  = d.getDate().toString();
  var hh  = d.getHours().toString();
  var min  = d.getMinutes().toString();
  var ss  = d.getSeconds().toString();
  return (dd[1]?dd:"0"+dd[0]) + '.' + (mm[1]?mm:"0"+mm[0]) + '.' + yyyy + ' ' + hh + ':' + min + ':' + ss; // padding
};

class MemberName extends React.Component {
  static propTypes = {
    date: ReactPropTypes.number, // milisec
    timeago: ReactPropTypes.bool, // vai iespējot timeago
  };

  static defaultProps = {
    date: null,
    timeago: false,
  };

  render() {
    if (!this.props.date) {
      return (<span />);
    }

    const dateNew = new Date(this.props.date);
    const currDate = new Date();
    const timeDiff = Math.abs(currDate.getTime() - dateNew.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    let showDate = true;

    // cik veciem ziņojumiem rādīt tikai datumu
    if (this.props.timeago && diffDays <= 7 && typeof Number.isNaN === 'function') {
      showDate = false;
    }

    const dateIso = dateNew.toJSON(); // ISO 8601 - 2008-07-17T09:24:17Z
    return (
      <span>
        {!showDate ?
          <TimeAgo date={this.props.date} formatter={buildFormatter(timeagoTranslations.getTranslations()) } />
          :
          <time dateTime={dateIso}>
          {this.props.showDay ?
            fullDay(dateNew)
            :
            fullDayAndTime(dateNew)
            //dateNew.toLocaleString(get(globals, 'language', 'en'))
          }
          </time>
        }
      </span>
    );
  }
}

module.exports = MemberName;
